// extracted by mini-css-extract-plugin
export default {"tooltipBlock":"style_tooltipBlock__aKVpq","header":"style_header__P5P4P","tooltipBlockContent":"style_tooltipBlockContent__qFNQw"};